import { Feature } from "ol";
/**
 * コンテキストメニュー情報クラス
 */
export class MapContextMenuItem {
  /**
   * コンテキストメニュー名
   */
  contextMenuName: string;

  /**
   * コールバック処理
   */
  contextClickCallBack: any;

  /**
   * 削除対象かどうか
   */
  isDelete: boolean;

  /**
   * 選択地物情報
   */
  selectedFeature: Feature;

  /**
   * 削除対象地物ID
   */
  deleteFId: string;

  /**
   * コンテキストメニューID
   */
  id: string;

  /**
   * コンストラクタ
   * @param contextMenuName コンテキストメニュー名
   * @param contextClickCallBack コールバック処理
   * @param isDelete 削除対象かどうか
   * @param selectedFeature 選択地物情報
   * @param deleteFId 削除対象地物ID
   */
  constructor(
    contextMenuName: string,
    contextClickCallBack: any,
    isDelete: boolean,
    selectedFeature?: Feature,
    deleteFId?: string,
    id?: string
  ) {
    this.contextMenuName = contextMenuName;
    this.contextClickCallBack = contextClickCallBack;
    this.isDelete = isDelete;
    this.selectedFeature = selectedFeature;
    this.deleteFId = deleteFId;
    this.id = id;
  }
}
